// use-subscription-portal.ts — Subscription suite, action.

'use client';

import { useMemo } from 'react';
import type { CreateSubscriptionPortalResponse } from '@cabal/shared/domain/billing/subscription/types.js';
import { useApi } from '@/contexts/api';
import { useActionHook } from '@/lib/query/use-action-hook';
import type { ActionResult } from '@/types/async-protocol';

export function useSubscriptionPortal(): ActionResult<void, CreateSubscriptionPortalResponse> {
  const api = useApi();
  const apiSubscription = api.subscription;

  return useActionHook<void, CreateSubscriptionPortalResponse>(
    useMemo(
      () => ({
        mutationFn: () => apiSubscription.portal(),
      }),
      [apiSubscription],
    ),
  );
}
